module.exports = __webpack_public_path__ + "img/drum-steelpan.b91af6cc.svg";